import { Controller } from "@hotwired/stimulus"

// Dismisses a flash message, playing the exit transition before removing the
// element from the DOM. Entry is handled in CSS via @starting-style. Flashes
// also dismiss themselves after a delay; the timer is cleared on manual
// dismiss or when the controller disconnects (e.g. Turbo navigation).
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async dismiss() {
    if (this.leaving) return
    this.leaving = true
    clearTimeout(this.timeout)

    this.element.classList.add("flash--leaving")

    const animations = this.element.getAnimations()
    if (animations.length > 0) {
      await Promise.race([
        Promise.allSettled(animations.map((animation) => animation.finished)),
        new Promise((resolve) => setTimeout(resolve, 1000)),
      ])
    }

    this.element.remove()
  }
}
